import { UseCasePreliquidar } from '../../Preliquidar/Application/UseCasePreliquidar';

export class UseCasePreliquidarDocHP extends UseCasePreliquidar { }